import { BusinessDTO } from './business';
import { UserRole } from './user';

export type InvitationStatus = 'accepted' | 'rejected' | 'pending';

export enum EventUserPermissions {
  SELLER = 'SELLER',
  COPRODUCER = 'COPRODUCER',
}

export interface CreateInvitationEventDTO {
  event_id: string;
  permissions: EventUserPermissions;
  seller_comission_rate: number;
  seller_group_id?: string;
}

export default interface InvitationDTO {
  id: string;
  email: string;
  business_id: string;
  token: string;
  status: InvitationStatus;
  permissions: UserRole;
  business: BusinessDTO;
}

export interface CreateInvitationDTO {
  email: string;
  permissions: UserRole;
  seller_commission_rate?: number;
  invitation_events?: CreateInvitationEventDTO[];
}
